import type {
  ClientRequestAmbiguousField,
  ClientRequestPrefill,
  ClientRequestUnmappedFilter,
} from './clientRequestPrefill';
import { buildClientRequestPrefill } from './clientRequestPrefill';
import type { AppliedAdsFilterSnapshot } from './appliedAdsFilterSnapshot';

export interface StorefrontClientRequestRouteState {
  source: 'storefront';
  returnTo: string;
  title: string;
  prefill: ClientRequestPrefill;
  ambiguousFields: ClientRequestAmbiguousField[];
  unmappedFilters: ClientRequestUnmappedFilter[];
}

interface BuildStorefrontClientRequestRouteStateParams {
  returnTo: string;
  snapshot: AppliedAdsFilterSnapshot;
  title: string;
}

export const buildStorefrontClientRequestRouteState = ({
  returnTo,
  snapshot,
  title,
}: BuildStorefrontClientRequestRouteStateParams): StorefrontClientRequestRouteState => ({
  source: 'storefront',
  returnTo,
  title,
  ...buildClientRequestPrefill(snapshot),
});
